import { createRoot } from 'react-dom/client';

import '@proton/polyfill';

import PublicAppEntry from './content/PublicAppEntry';
import './style';

const container = document.querySelector('.app-root');
const root = createRoot(container!);
root.render(<PublicAppEntry />);
